module.exports = __webpack_public_path__ + "static/media/303ButtonLabel--runStop.72960d9c.svg";